import type { ConversationBoardDto } from '../api/types';
type Item = ConversationBoardDto['items'][number];
export const boardProjectKey = (item: Item) => item.projectKey ?? item.projectCwd ?? item.review?.projectCwd ?? (item.owner === 'produto' ? 'product:term-deck' : item.project ?? 'unassigned');
export const boardProjectName = (item: Item) => item.projectCwd?.replace(/\\/g, '/').split('/').filter(Boolean).at(-1)
  ?? item.review?.projectCwd?.replace(/\\/g, '/').split('/').filter(Boolean).at(-1)
  ?? (item.owner === 'produto' ? 'TermDeck' : item.project ?? 'Sem projeto definido');
export function boardProjects(items: Item[]) {
  const groups = new Map<string, { key: string; name: string; cwd?: string | undefined; open: number; total: number }>();
  for (const item of items) {
    const key = boardProjectKey(item);
    const group = groups.get(key) ?? { key, name: boardProjectName(item), cwd: item.projectCwd ?? item.review?.projectCwd, open: 0, total: 0 };
    group.total++; if (item.state !== 'concluido') group.open++;
    groups.set(key, group);
  }
  return [...groups.values()].sort((a, b) => b.open - a.open || a.name.localeCompare(b.name, 'pt-BR') || a.key.localeCompare(b.key));
}
